/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: directory-service.ts
 *
 * Created by kyang on 2020-09-10.
 */

function DirectoryServiceConstructor (
    this: JS5Object,
    _: JS5Object,
    DirectoryResourceFactory: JS5Object,
) {
    this.getDirectories = (criteria: JS5Object) => {
        let finalCriteria = _.omit(criteria, ['fetchOffset', 'fetchLimit', 'searchString']);
        let firstIndex = _.get(criteria, 'fetchOffset', 0);
        let lastIndex = firstIndex + _.get(criteria, 'fetchLimit', 25) - 1;
        finalCriteria.range = `storageDirectories ${firstIndex}-${lastIndex}`;
        finalCriteria.name = _.get(criteria, 'searchString');
        return DirectoryResourceFactory.query(finalCriteria).$promise;
    };

    this.getDirectory = (id: string) => {
        return DirectoryResourceFactory.getDirectory({id: id}).$promise;
    }

    this.createDirectory = (directory: JS5Object) => {
        return DirectoryResourceFactory.createDirectory(directory).$promise;
    }

    this.updateDirectory = (directory: JS5Object) => {
        return DirectoryResourceFactory.updateDirectory(directory).$promise;
    }

    this.moveDirectory = (directory: JS5Object, targetFileSystemId: string) => {
        let directoryCopy = _.assign({}, directory, {filesystemId: targetFileSystemId});
        return this.updateDirectory(directoryCopy);
    };
}

angular
    .module('prism-ui.fileSystem')
    .service(
        'DirectoryService',
        DirectoryServiceConstructor
    );
